import script from "./HorizontalScrolling.vue?vue&type=script&setup=true&lang=js"
export * from "./HorizontalScrolling.vue?vue&type=script&setup=true&lang=js"

import "./HorizontalScrolling.vue?vue&type=style&index=0&id=88c9a2e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88c9a2e8"]])

export default __exports__